import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import React from 'react'
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import APIS from '../../../constant/EndPoint';
import Button from '../../Reusable/Button';
import ComboboxInput from '../../Reusable/Form/ComboboxInput';

let assignToRiderValidationForm = yup.object().shape({
  rider: yup.string().required("Status is required"),
  status: yup.string().required("Rider Status is required"),
});
const AssignToRider = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(assignToRiderValidationForm),
  });
  return (
    <div className='flex flex-col justify-between min-h-full'>
      <ComboboxInput
        url={`${APIS.STATUS}rider-status/`}
        queryKey={"rider-status"}
        register={register("status")}
        errors={errors?.rider_status}
        name={"status"}
        label={""}
        setValue={setValue}
        placeholder={"Search Status"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <ComboboxInput
        url={APIS.RIDER}
        queryKey={"rider"}
        register={register("rider")}
        errors={errors?.rider}
        name={"rider"}
        label={""}
        setValue={setValue}
        placeholder={"Search Rider"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className="w-[100px] mr-4 absolute bottom-4 right-2">
        <Button
          label={"Submit"}
          onClick={handleSubmit((data: any) =>
            props?.handleActionMenu(data, "Assign To Rider", setError)
          )}
        />
      </div>
    </div>
  )
}

export default AssignToRider
